export default __webpack_public_path__ + "static/pragicts-68ec9136eead5cb6701eebaa0e175ea8.png";